import * as Yup from "yup";

export const UserSchema = Yup.object().shape({
    name: Yup.string().required("* required"),
    surname: Yup.string().required("* required"),
});